// import { StrictMode } from 'react';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { AppProviders } from "./AppProviders.tsx";
import "./index.css";
import i18n, { i18nReady } from "./translations/i18n";

// NOTE: three's Clock-deprecation console shim lives in src/lib/textureCache.ts
// (inside the lazy viewer/editor chunks). Importing three here — even just for
// setConsoleFunction — dragged vendor-three (~170KB gz) into the entry chunk
// for every page, including the landings.

// Sync HTML lang attribute with i18next active language (fires on init too —
// with the lazy backend, i18n.language isn't set yet at module-eval time).
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

// Vercel Toolbar en localhost. ponytail: inyección directa del script en vez de
// @vercel/toolbar — el paquete sólo hace esto mismo leyendo los ids de env/.vercel.
// Dev-only: `import.meta.env.DEV` es false en build ⇒ el bloque se elimina.
// Requiere estar logueado en vercel.com con acceso al proyecto tour-saas.
if (import.meta.env.DEV) {
  const s = document.createElement("script");
  s.src = "https://vercel.live/_next-live/feedback/feedback.js";
  s.dataset.explicitOptIn = "true";
  s.dataset.ownerId = "team_rnKfUOFpWOsgk0j9VUkG8jKT";
  s.dataset.projectId = "prj_yLFAo0uvxr6PIv0RnvlIw7JcUUA6";
  s.dataset.branch = "main";
  document.head.appendChild(s);
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("No se encontró el elemento #root en el DOM");

// Gate the first render on the (lazy) initial locale bundle — one small JSON
// fetch instead of 5 bundled languages; avoids flashing raw i18n keys.
void i18nReady.then(() =>
  ReactDOM.createRoot(rootElement).render(
    <>
      <AppProviders>
        <App />
      </AppProviders>
      <Analytics />
      <SpeedInsights />
    </>,
  ),
);
